import CustomFileInput from "./CustomFileInput";

const UAE_Files = ({
  styles,
  setFieldValue,
  setFieldTouched,
  touched,
  setFieldError,
  errors,
  t,
  phone,
  values,
  setPassportUrl,
  setWorkPermit,
  sethrLetter,
  setbankStatement,
  clearFileNames, /////////////////
  setUpload,
}) => {
  const fileInputConfigs = [
    {
      name: "passportUrl",
      id: "passportUrl",
      textHtmlFor: "passportUrl",
      label: t.form_labels.passport_copy,
      setURL: setPassportUrl,
    },
    {
      name: "workPermitUrl",
      id: "workPermitUrl",
      textHtmlFor: "workPermitUrl",
      label: t.form_labels.work_permit,
      setURL: setWorkPermit,
    },
    {
      name: "hrLetter",
      id: "hrLetter",
      textHtmlFor: "hrLetter",
      label: t.form_labels.hr_letter,
      setURL: sethrLetter,
    },
    {
      name: "bankStatementUrl",
      id: "bankStatementUrl",
      textHtmlFor: "bankStatementUrl",
      label: t.form_labels.bank_statement,
      setURL: setbankStatement,
    },
  ];

  return (
    <>
      {fileInputConfigs.map((config, index) => (
        <CustomFileInput
          key={index}
          name={config.name}
          id={config.id}
          textHtmlFor={config.textHtmlFor}
          label={config.label}
          styles={styles}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          touched={touched}
          setFieldError={setFieldError}
          errors={errors}
          t={t}
          phone={phone}
          setURL={config.setURL}
          clearFileName={clearFileNames} /////////////
          setUpload={setUpload}
          type="uae"
        />
      ))}
    </>
  );
};

export default UAE_Files;
